"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDropdownPlugins = void 0;
var _docs = _interopRequireDefault(require("@adsk/acc-reference-picker/es/plugins/docs"));
var _sheets = _interopRequireDefault(require("@adsk/acc-reference-picker/es/plugins/sheets"));
var _react = require("react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useDropdownPlugins = () => {
  return (0, _react.useMemo)(() => ({
    docsPlugin: _docs.default,
    sheetsPlugin: _sheets.default
  }), []);
};
exports.useDropdownPlugins = useDropdownPlugins;
//# sourceMappingURL=useDropdownPlugins.js.map